import { useRouter } from "next/router";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import styled from "styled-components";
import { adLinksAPI } from "../../api/adLinks";
import Layout from "../../components/layout/Layout";
import Seo from "../../components/layout/Seo";
import Head from "next/head";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  & h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 30px;
  }
  & span {
    margin-bottom: 30px;
    font-size: 18px;
  }
`;

const QPage = () => {
  const router = useRouter();

  const fetchURL = async () => {
    const body = {
      modes: "GetUrl",
      code: router.query.code,
    };
    const res = await adLinksAPI(body);
    if (res.Code === "0000") {
      router.push(res.Data?.Link);
    } else {
      router.push("/");
    }
  };

  useEffect(() => {
    if (!router.isReady) return;
    fetchURL();
  }, [router.isReady]);

  return (
    <>
      <link rel="canonical" href="/q" />
      <Head>
        <title>{"포장재는 칼렛! | 포장재 맞춤제작·친환경 포장재 칼렛스토어"}</title>
        <meta
          name="naver-site-verification"
          content="73434c46afaf95b1aca89b69bf1bbd9b18d465c8"
        />
        <meta
          property="og:site_name"
          content="칼렛스토어 :: 미래의 당연함을 만들다"
        />
        <meta
          property="og:title"
          content={"포장재는 칼렛! | 포장재 맞춤제작·친환경 포장재 칼렛스토어"}
        />
        <meta property="og:description" content="박스·봉투·테이프·완충재부터 친환경 포장재까지. 기성품 구매, 소량인쇄, 로고인쇄, 브랜드 맞춤제작과 기업 대량견적을 한번에 해결하세요." />

        <meta property="og:url" content={`https://www.caretstore.co.kr`} />

        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://file.caretbio.com/caretbio/39c77d036143e36fb234b8281dc17bba.jpeg"
        />
      </Head>
      <Container>
        <img src="/assets/imgs/theme/logo-header-icon.png" />
        <LoadingWrapper>
          <span>페이지 이동중입니다.</span>
          <Spinner />
        </LoadingWrapper>
      </Container>
    </>
  );
};
export default QPage;
